import { DateTime } from "luxon";

/**
 * @property {DateTime|null} date.signature
 * @property {DateTime|null} date.publication
 * @property {string|null} link
 * @property {string|null} file
 */
export default class Amendment {
    constructor() {
        this.date = {
            signature: null,
            publication: null
        };
        this.link = null;
        this.file = null;
    }

    /**
     * @param {Object} api_resource
     * @returns {Amendment}
     */
    static fromAPI(api_resource) {
        let out = new Amendment();
        return Object.assign(out, {
            date: Object.freeze(Object.assign(out.date, {
                signature: (api_resource.date.signature !== null
                    ? DateTime.fromISO(api_resource.date.signature)
                    : null
                ),
                publication: (api_resource.date.publication !== null
                    ? DateTime.fromISO(api_resource.date.publication)
                    : null
                )
            })),
            link: api_resource.link,
            file: api_resource.file
        });
    }
}
